import React from 'react';
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import { withStyles, Button, withWidth } from '@material-ui/core';
import PropTypes from 'prop-types';
import ErrorDialogsuccess from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonDashboard from '../../components/CommonDashBord';
import {StatusCodes} from 'http-status-codes';
import Title from '../../components/CommonDashboardTitle';
import {buildData, handleError} from "../../components/DeleteRecurring";
const styles = theme => ({
    root: {marginTop: theme.spacing(3),...theme.mixins.gutters(),paddingTop: theme.spacing(1),paddingBottom: theme.spacing(1),},
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid${theme.palette.border.primaryBorder}`,
    borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px", textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor,
    border: `1px solid ${theme.palette.border.hoverPrimaryBorder}` } },
    pad0: { padding: 0 },
     tableStyle: {maxWidth: "1200px", margin: '0px auto', padding: "0",[theme.breakpoints.down("sm")]: {margin: 0 }},
    loadingBody:{minHeight:'100vh'},
});

class ArticleList extends React.Component {
    state = {
         Meditationdata:[] ,
        inactivate: false,
        TotalMeditation: '',
        loading: true,
        MeditationListCount: 0,
        // deleteTriviaId:'',
        reqAttentionCount:0,
        reqAttentionFilter:"1",
        Open:false,
        id:0,
        dialogueLoad: false,
        deleteDialogStatus:false,
        deleteMessage:"",
        version:null
    };

    handleMeditationEditUser = (resourceid,variant,version, clone,newversion_clone) => {
        const selectedarticle = this.state.Meditationdata.filter((n) =>n.resourceid === resourceid);
        const Medversiondata=selectedarticle.filter((n) =>n.versionNumber === version);
    if(!clone){
        this.props.history.push({
            pathname: `./Meditation/Edit/${resourceid}/${variant}`,
            clone,newversion_clone,
            state: { detail:Medversiondata }
          });
    } else {
        this.props.history.push({
            pathname: `./Meditation/Edit/Clone/${resourceid}/${variant}`,
            clone,newversion_clone,
            state: { detail:Medversiondata }
          });
    }
    };
     handleMeditationdeletepopup=(resourceid, version)=>{
  this.setState({Open:true,id:resourceid, version});
};
    handleDeleteUserMeditation = async () => {
        this.setState({dialogueLoad:true, Open:false})
        let response = await this.props.authenticatedApiCall('post', '/api/content/contentservice/deleteMeditationResource', buildData(this.state.Meditationdata, this.state.id, this.state.version));
        this.setState({dialogueLoad:false, deleteDialogStatus:true})
        const ErrorMsg = handleError(response);
        this.setState({deleteMessage: ErrorMsg});
    };
 handleCloseDialogMeditation = () => {
     this.setState({Open:false});
  };
    async componentDidMount() {
        let response = await this.props.authenticatedApiCall('get', '/api/content/contentservice/getMeditationResource', null);
        if (response && response.status === StatusCodes.OK) {
            this.setState({TotalMeditation:response.data.data.length,MeditationListCount:response.data.data.length});
            this.setState({ Meditationdata:response.data.data});
        }
        else {
            this.setState({Meditationdata: []});
        }
    }
   handleAddNewMeditation = () => {
      this.props.history.push("./Meditation/New");
    };
    handleDeleteDialogClose = () => {
        this.props.history.go(0);
      }
    render() {
        const { classes} = this.props;
            const okbutton = [
      <Button className={classes.primaryBtn} onClick={this.handleCloseDialogMeditation} >No</Button>,
      <Button className={classes.primaryBtn} onClick={this.handleDeleteUserMeditation}>Yes</Button>
    ];
    const deleteDialogButton = [ <Button className={classes.primaryBtn} onClick={this.handleDeleteDialogClose}>Close</Button> ];
    const errorMessage = "Are you sure you want to delete this Meditation?";
        return (
            <div>
                <div className={classes.tableStyle}>
                 <Title titlename={"Meditation"} count={this.state.TotalMeditation}  button3={this.handleAddNewMeditation}/>
                {(this.state.TotalMeditation==="" && this.state.loading) && <div className={classes.loadingBody}><CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"50%"}}/></div>}
                {this.state.Meditationdata && this.state.Meditationdata.length>0? <CommonDashboard  patientList = {this.state.Meditationdata} reqAttentionFilter={this.state.reqAttentionFilter}
                handleEditUser={this.handleMeditationEditUser}  handleDeleteUser={this.handleMeditationdeletepopup}  handleAddNewPatient={this.handleAddNewMeditation} name={"meditation"} />:""}
                </div>
                 {this.state.Open? <ErrorDialogsuccess successButton={okbutton}  HeaderText={errorMessage}  dismiss={this.handleCloseDialogMeditation}/>:""}
                 {this.state.deleteDialogStatus && <SuccessDialog successButton={deleteDialogButton} HeaderText={"Success"} BodyText={this.state.deleteMessage}  dismiss={this.handleDeleteDialogClose}/>}
                {this.state.dialogueLoad && <div className={classes.loadingBody}> <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"75%"}}/></div>}
            </div>
        );
    }
}
ArticleList.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withWidth()((withStyles(styles)(AuthenticatedPage()(ArticleList))));